// name of all vars stored in local/session Storage or cookies
export const ACCESS_TOKEN = 'AccessToken';
export const REFRESH_TOKEN = 'RefreshToken';
export const ID_TOKEN = 'idToken';
